export const headerNavItems = [
  {
    title: "",
    navLinks: [
      {
        link: "/renew",
        name: "Renewal",
        component: "NavItemAccountApp"
      },
      {
        link: "/",
        name: "Account Home",
        component: "NavItemAccountApp"
      },
      {
        link: "/usage",
        name: "Energy Usage",
        component: "NavItemAccountApp"
      },
      {
        link: "/readings",
        name: "Meter Readings",
        component: "NavItemAccountApp"
      },

      {
        link: "/balance",
        name: "Bills & Transactions",
        component: "NavItemAccountApp"
      },
      {
        link: "/payments",
        name: "Payments",
        component: "NavItemAccountApp"
      },
      {
        link: "/tariff",
        name: "Tariff Details",
        component: "NavItemAccountApp"
      },
      ...(process.env.VUE_APP_USE_NEXUS_PROFILE_PAGE !== "true"
        ? [
            {
              link: "/personal-details",
              name: "Personal Details",
              component: "NavItemAccountApp"
            }
          ]
        : []),
      {
        link: "/refer",
        name: "Refer a Friend",
        component: "NavItemAccountApp"
      },
      {
        link: `${process.env.VUE_APP_WEBSITE_URL}/help/moving`,
        name: "Moving Home",
        component: "NavItemAccountApp"
      },
      {
        link: `${process.env.VUE_APP_WEBSITE_URL}/products/all-products`,
        name: "All Products",
        component: "NavItemAccountApp"
      },
      {
        link: "/choose",
        name: "Change Account",
        component: "NavItemAccountApp"
      },
      {
        link: `${process.env.VUE_APP_WEBSITE_URL}/warm-home-discount`,
        name: "Warm Home Discount",
        component: "NavItem"
      }
    ],
    navTitle: [
      {
        link: "",
        name: "Account",
        component: "NavItemAccount"
      }
    ],
    hideWhenLoggedIn: false,
    hideWhenLoggedOut: true
  },
  {
    title: "",
    navTitle: [
      {
        link: `${process.env.VUE_APP_WEBSITE_URL}/energy/quote`,
        name: "Get a quote",
        component: "NavItem"
      }
    ],
    showAsButton: true,
    hideWhenLoggedIn: true,
    hideWhenLoggedOut: false
  },
  {
    title: "",
    navLinks: [],
    navTitle: [
      {
        link: `${process.env.VUE_APP_WEBSITE_URL}/help/moving`,
        name: "Moving Home",
        component: "NavItem"
      },
      {
        link: "https://soenergy.typeform.com/to/rPtlwK",
        name: "Moving home",
        component: "NavItem"
      }
    ],
    tracking: [],
    component: "Nav",
    hideWhenLoggedIn: false,
    hideWhenLoggedOut: false
  },
  {
    title: "",
    navLinks: [],
    navTitle: [
      {
        link: "/move-out/status",
        name: "Moving Home",
        component: "NavItemAccountApp"
      }
    ],
    tracking: [],
    component: "Nav",
    hideWhenLoggedIn: false,
    hideWhenLoggedOut: true
  },
  {
    title: "",
    navLinks: [],
    navTitle: [
      {
        link: "/readings",
        name: "Meter Readings",
        component: "NavItemAccountApp"
      }
    ],
    tracking: [],
    component: "Nav",
    hideWhenLoggedIn: false,
    hideWhenLoggedOut: false
  },
  {
    title: "",
    navLinks: [
      {
        link: `${process.env.VUE_APP_WEBSITE_URL}/about-us`,
        name: "About So Energy",
        component: "NavItem"
      },
      {
        link: `${process.env.VUE_APP_WEBSITE_URL}/about-us/reviews`,
        name: "Customer Reviews",
        component: "NavItem"
      },
      {
        link: `${process.env.VUE_APP_WEBSITE_URL}/news`,
        name: "News & Views",
        component: "NavItem"
      },
      {
        link: "https://careers.so.energy/",
        name: "Work for So",
        component: "NavItem"
      },
      {
        link: `${process.env.VUE_APP_WEBSITE_URL}/our-energy`,
        name: "Our Energy",
        component: "NavItem"
      }
    ],
    navTitle: [
      {
        link: "",
        name: "About us",
        component: "NavItem"
      }
    ],
    hideWhenLoggedIn: false,
    hideWhenLoggedOut: false
  },
  {
    title: "",
    navLinks: [
      {
        link: `${process.env.VUE_APP_WEBSITE_URL}/support/home`,
        name: "Get Support",
        component: "NavItem"
      },
      {
        link: `${process.env.VUE_APP_WEBSITE_URL}/energy/saving`,
        name: "Energy Saving Tips",
        tracking: [],
        component: "NavItem"
      },
      {
        link: `${process.env.VUE_APP_WEBSITE_URL}/help/unhappy`,
        name: "Unhappy with Us?",
        component: "NavItem"
      },
      {
        link: `${process.env.VUE_APP_WEBSITE_URL}/help/emergency`,
        name: "Emergency",
        component: "NavItem"
      },
      {
        link: `${process.env.VUE_APP_WEBSITE_URL}/energy/price-cap`,
        name: "Price Cap",
        component: "NavItem"
      },
      {
        link: `${process.env.VUE_APP_WEBSITE_URL}/troubleshooting-ihd`,
        name: "IHD Troubleshooting",
        component: "NavItem"
      }
    ],
    navTitle: [
      {
        link: "",
        name: "Help",
        component: "NavItem"
      }
    ],
    fontColor: "#1A1A1A",
    backgroundColor: "#939393",
    hideWhenLoggedIn: false,
    hideWhenLoggedOut: false
  },
  {
    title: "",
    navLinks: [
      {
        link: `${process.env.VUE_APP_WEBSITE_URL}/solar/quote?utm_source=my_account&utm_medium=nav_bar`,
        name: "Solar",
        tracking: [
          {
            area: "",
            name: "Click - Solar",
            gaLabel: "",
            section: "",
            gaAction: "",
            component: "AnalyticsEvent",
            gaCategory: "",
            captureCurrentPage: true
          }
        ],
        component: "NavItem",
        hideForSites: []
      },
      {
        link: `${process.env.VUE_APP_WEBSITE_URL}/heating/so-home-cover`,
        name: "Home Cover",
        component: "NavItemAccountApp"
      },
      {
        link: `${process.env.VUE_APP_WEBSITE_URL}/heating/so-heat-pumps`,
        name: "Heat Pumps",
        component: "NavItem"
      },
      {
        link: `${process.env.VUE_APP_WEBSITE_URL}/energy/smart-meters`,
        name: "Smart Meters",
        component: "NavItem"
      }
    ],
    navTitle: [
      {
        link: "",
        name: "Products"
      }
    ],
    hideWhenLoggedIn: false,
    hideWhenLoggedOut: false
  },
  ...(process.env.VUE_APP_USE_NEXUS_PROFILE_PAGE === "true"
    ? [
        {
          title: "",
          navLinks: [],
          navTitle: [
            {
              link: `${process.env.VUE_APP_WEBSITE_URL}/myaccount/profile`,
              name: "Profile",
              component: "NavItemAccountApp"
            }
          ],
          hideWhenLoggedIn: false,
          hideWhenLoggedOut: true
        }
      ]
    : [])
]
